// extracted by mini-css-extract-plugin
export default {"productCell":"loadShipmentItemsTable_productCell__5BgSh","loaded":"loadShipmentItemsTable_loaded__y36IM"};